var _path, _path2, _path3, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLikes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 52,
    viewBox: "0 0 73 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9755 32.3761L53.0116 44.6555C53.4607 45.0784 53.6852 45.2899 53.9499 45.342C54.0692 45.3655 54.1918 45.3655 54.311 45.342C54.5757 45.2899 54.8003 45.0784 55.2493 44.6555L68.2854 32.3761C71.9533 28.9212 72.3987 23.2358 69.3139 19.249L68.7338 18.4994C65.0435 13.73 57.636 14.5299 55.043 19.9777C54.6767 20.7472 53.5843 20.7472 53.218 19.9777C50.6249 14.5299 43.2174 13.73 39.5271 18.4994L38.9471 19.249C35.8622 23.2358 36.3077 28.9212 39.9755 32.3761Z",
    fill: "currentColor",
    fillOpacity: 0.05,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1276 29.3608L27.8545 49.8264C28.6029 50.5314 28.9771 50.8839 29.4183 50.9707C29.617 51.0098 29.8214 51.0098 30.0201 50.9707C30.4613 50.8839 30.8355 50.5314 31.584 49.8264L53.3109 29.3608C59.4239 23.6026 60.1663 14.127 55.0249 7.4823L54.0582 6.2329C47.9076 -1.71602 35.5618 -0.382925 31.2401 8.6968C30.6296 9.97936 28.8089 9.97936 28.1984 8.6968C23.8766 -0.382925 11.5309 -1.71601 5.38031 6.23292L4.41358 7.48231C-0.727798 14.127 0.0145479 23.6026 6.1276 29.3608Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5758 28.5779C24.1966 28.0403 25.045 27.6283 26.005 27.3512C26.9709 27.0724 28.0527 26.929 29.1448 26.929C30.2368 26.929 31.3186 27.0724 32.2845 27.3512C33.2445 27.6283 34.0929 28.0403 34.7137 28.5779",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0403,
    cy: 19.1769,
    rx: 1.75905,
    ry: 1.75905,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8357,
    cy: 19.1769,
    rx: 1.75905,
    ry: 1.75905,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLikes);
export default __webpack_public_path__ + "static/media/no-likes.57b4f7c5b1956f75c45b1fde83b26d64.svg";
export { ForwardRef as ReactComponent };